import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isDesktop", "onOpenPopover", "links"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LanguageSelector, PointsButton } from '@infl-ts/ui-advocate-components';
import { DE$ } from '@infl-ts/util-datum';
import { Box, Skeleton } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { flow, pipe } from 'fp-ts/function';
import { useRef } from 'react';
import { useConsentStatus, useGetNavBarInfo } from '../queries';
import { DesktopActionBarPopover, MobileActionBarPopover } from './action-bar-popover';
import AuthButtons from './auth-buttons';
import Chat from './chat';
import Notifications from './notifications';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ActionBarSkeleton = function ActionBarSkeleton() {
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      ml: 2
    },
    "data-element": "Box",
    "data-component": "ActionBarSkeleton",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      sx: {
        ml: 0.5,
        mr: 1
      },
      variant: "circular",
      width: 30,
      height: 30,
      "data-element": "Skeleton",
      "data-component": "ActionBarSkeleton",
      "data-source-file": "index.tsx"
    }), /*#__PURE__*/_jsx(Skeleton, {
      sx: {
        mx: 0.5
      },
      variant: "circular",
      width: 30,
      height: 30,
      "data-element": "Skeleton",
      "data-source-file": "index.tsx"
    }), /*#__PURE__*/_jsx(Skeleton, {
      sx: {
        mx: 1
      },
      width: 35,
      "data-element": "Skeleton",
      "data-source-file": "index.tsx"
    }), /*#__PURE__*/_jsx(Skeleton, {
      sx: {
        m: 1
      },
      variant: "circular",
      width: 35,
      height: 35,
      "data-element": "Skeleton",
      "data-source-file": "index.tsx"
    })]
  });
};

export var PureActionBar = function PureActionBar(_ref) {
  var profile = _ref.profile,
      unreadNotifications = _ref.unreadNotifications,
      links = _ref.links,
      isDesktop = _ref.isDesktop,
      signupEnabled = _ref.signupEnabled,
      signinEnabled = _ref.signinEnabled,
      notificationsEnabled = _ref.notificationsEnabled,
      memberMessagingEnabled = _ref.memberMessagingEnabled,
      messagingLink = _ref.messagingLink,
      privacyPolicyLink = _ref.privacyPolicyLink,
      termsAndConditionsLink = _ref.termsAndConditionsLink,
      actionBarLangSelectorEnabled = _ref.actionBarLangSelectorEnabled,
      navLangSelectorEnabled = _ref.navLangSelectorEnabled,
      onOpenPopover = _ref.onOpenPopover;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      ml: 2
    },
    "data-element": "Box",
    "data-component": "PureActionBar",
    "data-source-file": "index.tsx",
    children: [notificationsEnabled && profile ? /*#__PURE__*/_jsx(Notifications, {
      profile: profile,
      unreadNotifications: unreadNotifications !== null && unreadNotifications !== void 0 ? unreadNotifications : 0
    }) : null, profile && memberMessagingEnabled ? /*#__PURE__*/_jsx(Chat, {
      messagingLink: messagingLink,
      profile: profile
    }) : null, profile !== null && profile !== void 0 && profile.currentPoints ? /*#__PURE__*/_jsx(PointsButton, {
      currentPoints: profile.currentPoints
    }) : null, navLangSelectorEnabled ? /*#__PURE__*/_jsx(LanguageSelector, {
      containerSx: {
        display: {
          sm: 'none',
          lg: 'flex'
        }
      },
      reloadOnLanguageChange: true
    }) : null, signinEnabled || signupEnabled ? /*#__PURE__*/_jsx(AuthButtons, {
      containerSx: {
        display: {
          xs: 'none',
          md: 'flex'
        },
        justifyContent: 'flex-end'
      },
      signinEnabled: signinEnabled,
      signupEnabled: signupEnabled
    }) : null, isDesktop ? /*#__PURE__*/_jsx(DesktopActionBarPopover, {
      onOpen: onOpenPopover,
      profile: profile,
      privacyPolicyLink: privacyPolicyLink,
      termsAndConditionsLink: termsAndConditionsLink,
      memberMessagingEnabled: memberMessagingEnabled,
      actionBarLangSelectorEnabled: actionBarLangSelectorEnabled
    }) : /*#__PURE__*/_jsx(MobileActionBarPopover, {
      onOpen: onOpenPopover,
      links: links,
      profile: profile,
      signinEnabled: signinEnabled,
      signupEnabled: signupEnabled,
      privacyPolicyLink: privacyPolicyLink,
      termsAndConditionsLink: termsAndConditionsLink,
      memberMessagingEnabled: memberMessagingEnabled,
      actionBarLangSelectorEnabled: actionBarLangSelectorEnabled,
      navLangSelectorEnabled: navLangSelectorEnabled
    })]
  });
};

var ActionBarWithProfile = function ActionBarWithProfile(_ref2) {
  var isDesktop = _ref2.isDesktop,
      onOpenPopover = _ref2.onOpenPopover,
      links = _ref2.links,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return pipe(useGetNavBarInfo(), DE.squash(function () {
    return /*#__PURE__*/_jsx(ActionBarSkeleton, {});
  }, function () {
    return isDesktop ? /*#__PURE__*/_jsx(DesktopActionBarPopover, {
      onOpen: onOpenPopover,
      profile: undefined,
      privacyPolicyLink: rest.privacyPolicyLink,
      termsAndConditionsLink: rest.termsAndConditionsLink,
      memberMessagingEnabled: rest.memberMessagingEnabled,
      actionBarLangSelectorEnabled: rest.actionBarLangSelectorEnabled
    }) : /*#__PURE__*/_jsx(MobileActionBarPopover, {
      onOpen: onOpenPopover,
      links: links,
      profile: undefined,
      signinEnabled: rest.signinEnabled,
      signupEnabled: rest.signupEnabled,
      privacyPolicyLink: rest.privacyPolicyLink,
      termsAndConditionsLink: rest.termsAndConditionsLink,
      memberMessagingEnabled: rest.memberMessagingEnabled,
      actionBarLangSelectorEnabled: rest.actionBarLangSelectorEnabled,
      navLangSelectorEnabled: rest.navLangSelectorEnabled
    });
  }, function (_ref3) {
    var profile = _ref3.profile,
        unreadNotifications = _ref3.unreadNotifications;
    return /*#__PURE__*/_jsx(PureActionBar, _objectSpread({
      onOpenPopover: onOpenPopover,
      isDesktop: isDesktop,
      profile: profile,
      unreadNotifications: unreadNotifications,
      links: links
    }, rest));
  }));
};

var useProps = function useProps(props) {
  var profileRef = useRef(null);
  return _objectSpread(_objectSpread({}, props), {}, {
    onOpenPopover: function onOpenPopover() {
      setTimeout(function () {
        return !!(profileRef !== null && profileRef !== void 0 && profileRef.current) && profileRef.current.focus();
      }, 0);
    },
    isConsented: pipe(useConsentStatus({
      skip: !props.profileEnabled
    }), DE.map(function (_ref4) {
      var consentStatus = _ref4.consentStatus;
      return consentStatus;
    }), DE$.getSuccessOrElse(false))
  });
};

export default Object.assign(flow(useProps, function (props) {
  return props.profileEnabled && props.isConsented ? /*#__PURE__*/_jsx(ActionBarWithProfile, _objectSpread({}, props)) : /*#__PURE__*/_jsx(PureActionBar, _objectSpread({}, props));
}), {
  displayName: 'ActionBar'
});